// 用来控制按钮的显示
export function hasBtnPermission(permission) {
    if (permission == null || trim(permission) == "") {
        return false;
    }
    let permissionSetStr = localStorage.getItem('permissionSet');
    if (permissionSetStr == null) {
        permissionSetStr = "[]";
    }
    const permissionSet = JSON.parse(permissionSetStr);
    let split = permission.split(",");
    for (let i = 0; i < split.length; i++) {
        if (permissionSet.includes(split[i])) {
            return true;
        }
    }
    return false;
}

function trim(str) { //删除左右两端的空格
    return str.replace(/(^\s*)|(\s*$)/g, "");
}
